var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('account-form',{attrs:{"mode":"new_visit"},on:{"confirmed":function($event){_vm.setConfirmed($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }